import axios from "axios";

let numberOfPendingRequests = 0;
let loadingTreshold = [];

const ax = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

ax.interceptors.response.use(
  (response) => {
    stopLoading();

    return response;
  },
  (error) => {
    stopLoading();

    let store = getStoreInstance();
    if (error.response.status == 401) {
      store.dispatch("auth/doLogout", true);

      let router = getRouterInstance();
      if (!["login", "account-activate"].includes(router.currentRoute.name)) {
        router.push({ name: "login" });
      }
    }

    return Promise.reject(error);
  }
);

ax.interceptors.request.use(
  (config) => {
    config.headers.Accept = "application/json";

    numberOfPendingRequests++;

    let store = getStoreInstance();

    let locale = store.getters["language/getLanguage"];
    config.headers["X-Lang"] = locale;
    config.headers["X-Device"] = process.env.VUE_APP_DEVICE;

    loadingTreshold.push(
      setTimeout(() => {
        store.dispatch("loading/startLoading");
      }, 450)
    );

    if (store.getters["auth/getLoginStatus"] === true) {
      const token = store.getters["user/getToken"];
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    return config;
  },
  (error) => {
    stopLoading();

    Promise.reject(error);
  }
);

function stopLoading() {
  loadingTreshold.map((id) => clearTimeout(id));
  loadingTreshold = [];

  numberOfPendingRequests--;
  let store = getStoreInstance();
  if (numberOfPendingRequests == 0) {
    store.dispatch("loading/stopLoading");
  }
}

export default ax;
